import { Filter } from '../filter';
import { ErrorType, FieldCondition, FieldValues } from '../types';

export class ConditionalFilter implements Filter<unknown> {
    constructor(
        private condition: FieldCondition,
        private filtersIfTrue: Array<Filter<unknown>>,
        private filtersIfFalse: Array<Filter<unknown>>,
    ) {}

    async validate(fieldValue: unknown, otherFields: FieldValues): Promise<Array<ErrorType>> {
        const filtersToUse = this.getFiltersToUse(otherFields);
        const errors: Array<ErrorType> = [];
        for (const filter of filtersToUse) {
            errors.push(...(await filter.validate(fieldValue, otherFields)));
        }
        return errors;
    }

    private getFiltersToUse(otherFields: FieldValues): Array<Filter<unknown>> {
        if (this.condition(otherFields)) {
            return this.filtersIfTrue;
        }
        return this.filtersIfFalse;
    }
}
